import { setFieldMandatory } from 'src/components/ui/inputs/FieldSet/FieldSet.utils'
import { PRICE_HUBBLE_REQUIRED_FIELDS } from 'src/pages/patrimony/Patrimony.const'
import type { ContextualFieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import {
  FIELD_RULES,
  FIELD_STATUSES,
} from 'src/tpbp-core/models/fields/fieldRules.const'
import { logger } from 'src/utils/logger.utils'
import _ from 'underscore'

export function computeCurrentSectionFields(
  availableFieldsByKey: _.Dictionary<ContextualFieldInterface>,
  fieldKeys: string[],
) {
  const currentSectionFields = filterFieldsKeepOrder(
    availableFieldsByKey,
    fieldKeys,
  )

  for (const field of currentSectionFields) {
    if (PRICE_HUBBLE_REQUIRED_FIELDS.includes(field.key)) {
      const newStatus = setFieldMandatory(field)

      field.status = newStatus
    }
  }

  return currentSectionFields
}

export function filterFieldsKeepOrder(
  fieldsByKey: Record<string, ContextualFieldInterface>,
  fieldKeys: string[],
  breaksByKey?: Record<string, boolean> | null,
) {
  return fieldKeys.reduce<ContextualFieldInterface[]>(
    (filteredFields, fieldKey) => {
      const field = fieldsByKey[fieldKey]

      if (!field) throw new Error(`Unknown field key ${fieldKey}`)

      if (field?.status && field.status !== FIELD_RULES.isHidden) {
        const copy = {
          ...field,
          displayBreak: breaksByKey?.[fieldKey] ?? false,
        } satisfies ContextualFieldInterface as ContextualFieldInterface
        filteredFields.push(copy)
      }

      return filteredFields
    },
    [],
  )
}

function filterFieldsWithoutFieldNames(fields: ContextualFieldInterface[]) {
  return fields.filter((field) => {
    if (field.type === FIELD_TYPES.break) {
      return true
    }
    const fieldRule = field.rule || field.dynamicRules
    if (!fieldRule) {
      logger.warn(`No rule on field '${field.key}'`)
    }
    return field.status && field.status !== FIELD_STATUSES.isHidden
  })
}

export function filterFields(
  fields: ContextualFieldInterface[],
  fieldNames: string[] = [],
  breakAfterFields: string[] = [],
) {
  if (fieldNames.length === 0) {
    return filterFieldsWithoutFieldNames(fields)
  }

  const fieldsByKey = _.indexBy(fields, 'key')
  const mapped = fieldNames.reduce<ContextualFieldInterface[]>(
    (fields, fieldName) => {
      if (!Object.hasOwn(fieldsByKey, fieldName)) {
        throw new Error(
          `Field '${fieldName}' not found in ${Object.keys(fieldsByKey).join(', ')}`,
        )
      }
      const field = fieldsByKey[fieldName]
      if (field !== undefined) {
        fields.push(field)
      }
      if (breakAfterFields.includes(fieldName)) {
        fields.push({ type: FIELD_TYPES.break } as ContextualFieldInterface)
      }
      return fields
    },
    [],
  )

  return filterFieldsWithoutFieldNames(mapped)
}

export function isValidStringTypeFormFieldValue(
  fieldValue: string | undefined,
): boolean {
  return !!fieldValue
}

export function isValidNumberTypeFormFieldValue(
  fieldValue: number | null | undefined,
): boolean {
  return (
    fieldValue !== undefined &&
    (fieldValue === null || !Number.isNaN(fieldValue))
  )
}
